import { render, staticRenderFns } from "./PolicyLookup.vue?vue&type=template&id=2cd30ae6&"
import script from "./PolicyLookup.vue?vue&type=script&lang=js&"
export * from "./PolicyLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports